import React,{useState,useMemo} from 'react';
import s from './Finalizados.module.css';
import {Btn} from '../UI/Btn';
import {Icons} from '../Sidebar/Icons';
import {Avatar} from '../UI/Avatar';
import {useStore} from '../../hooks/useStore';
import {store} from '../../utils/store';
import {fmtBRL,fmtDate,exportCSV} from '../../utils/helpers';

export function Finalizados(){
  const {agendamentos,profissionais}=useStore();
  const [q,setQ]=useState('');const [di,setDi]=useState('');const [df,setDf]=useState('');
  const list=useMemo(()=>agendamentos
    .filter(a=>a.status==='finalizado')
    .filter(a=>!q||a.clienteNome?.toLowerCase().includes(q.toLowerCase())||a.servico?.toLowerCase().includes(q.toLowerCase()))
    .filter(a=>!di||a.data>=di)
    .filter(a=>!df||a.data<=df)
    .sort((a,b)=>(a.finalizadoEm||'')>(b.finalizadoEm||'')?-1:1)
  ,[agendamentos,q,di,df]);

  const total=list.reduce((s,a)=>s+Number(a.valor||0),0);
  const del=async id=>{if(window.confirm('Excluir?'))await store.deleteAgendamento(id);};

  const exp=()=>{
    const h=['"Cliente"','"Profissional"','"Serviço"','"Data"','"Hora"','"Valor"'];
    const r=list.map(a=>{
      const p=profissionais.find(x=>x.id===a.profId);
      return[`"${a.clienteNome}"`,`"${p?.nome||''}"`,`"${a.servico}"`,`"${fmtDate(a.data)}"`,`"${a.hora}"`,`"R$ ${Number(a.valor).toFixed(2).replace('.',',')}"`].join(';');
    });
    exportCSV('finalizados.csv',h,r);
  };

  return(
    <div>
      <div className={s.bar}>
        <div className={s.srch}><Icons.Search/><input placeholder="Buscar cliente ou serviço..." value={q} onChange={e=>setQ(e.target.value)}/></div>
        <div className={s.dw}><Icons.Calendar/><input type="date" value={di} onChange={e=>setDi(e.target.value)}/></div>
        <div className={s.dw}><Icons.Calendar/><input type="date" value={df} onChange={e=>setDf(e.target.value)}/></div>
        <Btn variant="secondary" size="sm" icon={<Icons.Download/>} onClick={exp} style={{marginLeft:'auto'}}>CSV</Btn>
      </div>
      <div className={s.stats}>
        <div className={s.stat}><div className={s.sv}>{list.length}</div><div className={s.sl}>Finalizados</div></div>
        <div className={s.stat}><div className={s.sv} style={{color:'var(--green)'}}>{fmtBRL(total)}</div><div className={s.sl}>Total no período</div></div>
      </div>
      <div className={s.card}><div className={s.tw}>
        <table className={s.tb}>
          <thead><tr><th>Cliente</th><th>Profissional</th><th>Serviço</th><th>Data/Hora</th><th>Valor</th><th></th></tr></thead>
          <tbody>
            {list.length===0&&<tr><td colSpan={6}><div className={s.emp}><Icons.CheckCircle/><p>Nenhum atendimento finalizado.</p></div></td></tr>}
            {list.map((a,i)=>{
              const p=profissionais.find(x=>x.id===a.profId);
              const pi=profissionais.findIndex(x=>x.id===a.profId);
              return(
                <tr key={a.id}>
                  <td><div className={s.cn}>{a.clienteNome}</div><div className={s.cs}>{a.clienteWa}</div></td>
                  <td>
                    {p
                      ?<div style={{display:'flex',alignItems:'center',gap:7}}>
                          {p.foto
                            ?<img src={p.foto} alt={p.nome} style={{width:28,height:28,borderRadius:'50%',objectFit:'cover',flexShrink:0}}/>
                            :<Avatar name={p.nome} idx={pi} size={28}/>
                          }
                          <span style={{fontSize:13,color:'var(--g700)'}}>{p.nome}</span>
                        </div>
                      :<span style={{color:'var(--g300)'}}>—</span>
                    }
                  </td>
                  <td>{a.servico}</td>
                  <td><div className={s.cn}>{fmtDate(a.data)}</div><div className={s.cs}>{a.hora}</div></td>
                  <td><strong style={{color:'var(--green)'}}>{fmtBRL(a.valor)}</strong></td>
                  <td><button className={`${s.ab} ${s.ad}`} onClick={()=>del(a.id)}><Icons.Trash/></button></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div></div>
    </div>
  );
}
